// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Utils = require("./Utils.js");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

function str(prim) {
  return prim;
}

function onClickEvent(value, fn, param) {
  if (fn !== undefined) {
    Curry._1(fn, value);
  }
  return /* () */0;
}

function listItem(fn, param, it) {
  var partial_arg = it[/* value */0];
  return React.createElement("li", {
              key: it[/* value */0]
            }, React.createElement("a", {
                  onClick: (function (param) {
                      return onClickEvent(partial_arg, fn, param);
                    })
                }, it[/* label */1]));
}

var component = ReasonReact.statelessComponent("Dropdown");

function make($staropt$star, $staropt$star$1, onChange, value, $staropt$star$2, param) {
  var className = $staropt$star !== undefined ? $staropt$star : "";
  var menuClassName = $staropt$star$1 !== undefined ? $staropt$star$1 : "";
  var items = $staropt$star$2 !== undefined ? $staropt$star$2 : /* [] */0;
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (param) {
              return React.createElement("div", {
                          className: className + " una-dropdown btn-group"
                        }, React.cloneElement(React.createElement("button", {
                                  className: "dropdown-toggle",
                                  type: "button"
                                }), {
                              "data-toggle": "dropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            }, List.find((function (i) {
                                      return i[/* value */0] === value;
                                    }), items)[/* label */1]), React.createElement("ul", {
                              className: menuClassName + " dropdown-menu"
                            }, Utils.List[/* mapToElement */0]((function (param, param$1) {
                                    return listItem(onChange, param, param$1);
                                  }), items)));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

exports.str = str;
exports.onClickEvent = onClickEvent;
exports.listItem = listItem;
exports.component = component;
exports.make = make;
/* component Not a pure module */
